import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            特别企划
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精选热门综艺专题，深度了解你最爱的节目
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-primary-600 text-xs font-semibold">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <p className="text-xs text-primary-500 font-semibold mb-1">
                  {item.subtitle}
                </p>
                <h3 className="text-base font-bold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}